import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-current',
  templateUrl: './current.component.html',
  styleUrls: ['./current.component.scss']
})
export class CurrentComponent implements OnInit {


  currentPortfolioValue: string;
  newPortfolioValue: string;
  result: any;
  response: any;
  have_statistic: any;
  need_statistic: any;
  betaAvg:any;
  isSaving:boolean=false;

  constructor(public user: UserService, private _http: HttpClient,private toastr:ToastrService) { }

  ngOnInit() {
    // If the item is stored in a cookie retrieve that
    if(localStorage.getItem('beta_avg')!=undefined){
      this.betaAvg=localStorage.getItem('beta_avg')
    }

    if (localStorage.getItem('current_allocation') != undefined){
      this.user.getAllocation(localStorage.getItem('current_allocation')).subscribe(result => {
        this.result = result;
      });
    }
    // else get the data from the database
    else {
      // this._http.get(UserService.CHAPVEST_PATH+'data.json').subscribe(result =>{
      //   this.result = result;
      // });
      // this._http.get('http://13.57.236.169/angular/chapvest-project/data.json').subscribe(result =>{
      //   this.result = result;
      // });
      this._http.get( UserService.RESOURCES_PATH + '/data2.json').subscribe(result =>{
        this.result = result;
      });

    }
    // this._http.get('http://13.57.236.169/static_files/data2.json').subscribe(result =>{
    //   this.result = result;
    // });
    // this._http.get( UserService.RESOURCES_PATH + '/data2.json').subscribe(result =>{
    //   this.result = result;
    // });
    this.user.currentPortfolioValue.subscribe(currentPortfolioValue => {
      this.currentPortfolioValue = currentPortfolioValue;
      this.newPortfolioValue = currentPortfolioValue;
    });
    if (localStorage.getItem('current_need_statistic') != undefined){
      this.user.getStatistic(localStorage.getItem('current_need_statistic')).subscribe(statistic =>{
          this.need_statistic = statistic;
      });
    }
    if (localStorage.getItem('current_have_statistic') != undefined){
      this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
          this.have_statistic = statistic;
      });
    }
  }
  calculatePercentage(category_id){
    // Update the asset
    // Find the category by the id
    let category = this.result.CATEGORIES.find( obj => obj.category_id == category_id);
    let percentage = 0.0;
    let total_percentage = 0.0;
    for (let i = 0; i < category.ASSETS.length; i++){
        percentage += parseFloat(category.ASSETS[i].asset_percentage);
    }
    category.category_percentage = percentage;
    for (let i = 0; i < this.result.CATEGORIES.length; i++){
        total_percentage += parseFloat(this.result.CATEGORIES[i].category_percentage);
    }
    this.result.percentage = total_percentage;
  }
  percentageError(){
    this.toastr.warning("Percentages don't add up to 100%!")
  }
  portfolioValueError(){
    this.toastr.warning("Portfolio value must be greater than zero!")
  }
  clearAllocation(){
    localStorage.removeItem('current_allocation');
    localStorage.removeItem('current_have_statistic');
    localStorage.removeItem('beta_avg');
    this.betaAvg=undefined;
    this.have_statistic = {};
    this.need_statistic = {};
    this.result.percentage = 0.0;
    this.result.CATEGORIES.forEach( category => {
      category.category_percentage = 0.0;
      category.ASSETS.forEach( asset => {
          asset.asset_percentage = 0.0;
      });
    });
  }
  // Posting the allocation
  addAllocation(){


    if (this.result.percentage !== 100){
        this.percentageError();
    }
    else if(Number(this.currentPortfolioValue) <= 0) {
        this.portfolioValueError();
    }
    else{

      // Adds the html  elements
      var html = '';
      html += document.getElementById('allocation-table').innerHTML;
      html += document.getElementById('need-vs-have-table').innerHTML;
      this.user.html_body += html;

      // Adds the income_expense
      // Testing with dummy data
      // posts the new income expense and get response
      let assetValues=this.result.CATEGORIES.map(category=>category.ASSETS.map(asset=>Number(asset.asset_percentage) != 0 ? (Number(asset.asset_percentage)/100) *  Number(this.currentPortfolioValue) : 0))
      let merged = [].concat.apply([], assetValues);
      this.result.portfolio_value = Number(this.currentPortfolioValue);
      this.result.allocation=merged;
      this.user.allocation_categories=this.result.CATEGORIES
      this.user.isSaving=true;
      this.user.addAllocation(this.result).subscribe(response =>{
        // Gets the new response from POSTing the allocation
        this.user.isSaving=false;
        this.toastr.success(response["message"],'Portfolio Enhancer');
        this.response = response;
        this.betaAvg=this.response.createdAllocation.beta;
        localStorage.setItem('beta_avg',this.response.createdAllocation.beta);
        localStorage.removeItem('current_allocation');
        localStorage.setItem('current_allocation',this.response.createdAllocation._id);
        this.user.getAllocation(localStorage.getItem('current_allocation')).subscribe(result => {
          this.result = result;
        });
        localStorage.removeItem('current_have_statistic');
        localStorage.setItem('current_have_statistic',this.response.statistics_id);
        this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
          this.have_statistic = statistic;
        });
        let body = [
          {
            "propName": "allocation_id",
            "value": this.response.createdAllocation._id
          },
          {
            "propName": "have_statistics_id",
            "value": this.response.statistics_id
          }
        ]
        // // Create a new session associated with income expense
        // this.user.editSession(localStorage.getItem('current_session_id'), body).subscribe( session_response =>{
        //     // console.log(session_response);
        //     this.session_response = session_response;
        // });

      },(error)=>{
        this.user.isSaving=false;
        this.toastr.error('Something went wrong!')
      });
    }
  }

}
